export enum IVRKeyPresses {
  anyKey = 'anyKey',
}
